import L from 'leaflet';

// Import SVG icons directly from Assets folder
import semaforoSvg from '../../Assets/icons/semaforo.svg';
import rotatoriaSvg from '../../Assets/icons/rotatoria.png';

// Create the Leaflet icons using the imported SVG files
export const semaforoIcon = L.icon({
  iconUrl: semaforoSvg,
  iconSize: [20, 26],
  iconAnchor: [10, 26],
  popupAnchor: [0, -26],
  shadowUrl: null
});

export const rotatoriaIcon = L.icon({
  iconUrl: rotatoriaSvg,
  iconSize: [20, 20],
  iconAnchor: [10, 10],
  popupAnchor: [0, -10],
  shadowUrl: null
});

export default { semaforoIcon, rotatoriaIcon };
